import { Dispatch } from "redux";

import { PriorityStateAction } from "@reducers/types/taskManagement/settings/priority-state";

import {
  GET_TM_SETTINGS_PRIORITY,
  GET_SINGLE_TM_SETTINGS_PRIORITY,
  CREATE_TM_SETTINGS_PRIORITY,
  UPDATE_TM_SETTINGS_PRIORITY,
  DELETE_TM_SETTINGS_PRIORITY,
} from "./types";
import { PriorityCreateType } from "@type/taskManagement/settings/priority";
import {
  fetchPriority,
  fetchPriorityById,
  createPriority,
  updatePriority,
  deletePriority,
} from "@api/taskManagement/settings/priority";

export const priorityFetchActionHandler =
  (query: any) => async (dispatch: Dispatch<PriorityStateAction>) => {
    dispatch({ type: GET_TM_SETTINGS_PRIORITY.LOADING, payload: true });

    try {
      const res = await fetchPriority(query);

      const { priorities, page, size, total } = res.data || {};

      dispatch({
        type: GET_TM_SETTINGS_PRIORITY.SUCCESS,
        payload: {
          data: priorities,
          pagination: {
            page: page || 0,
            size: size || 0,
            total: total || 0,
          },
        },
      });
    } catch (err) {
      dispatch({ type: GET_TM_SETTINGS_PRIORITY.ERROR, payload: err });
    }
  };

export const priorityByIdFetchActionHandler =
  (id: string | number) => async (dispatch: Dispatch<PriorityStateAction>) => {
    dispatch({ type: GET_SINGLE_TM_SETTINGS_PRIORITY.LOADING, payload: true });

    try {
      const res = await fetchPriorityById(id);

      dispatch({
        type: GET_SINGLE_TM_SETTINGS_PRIORITY.SUCCESS,
        payload: res.data || {},
      });
    } catch (err) {
      dispatch({ type: GET_SINGLE_TM_SETTINGS_PRIORITY.ERROR, payload: err });
    }
  };

export const priorityCreateActionHandler =
  (data: PriorityCreateType) =>
  async (dispatch: Dispatch<PriorityStateAction>) => {
    dispatch({ type: CREATE_TM_SETTINGS_PRIORITY.LOADING, payload: true });

    try {
      const res = await createPriority(data);

      dispatch({
        type: CREATE_TM_SETTINGS_PRIORITY.SUCCESS,
        payload: res.data,
      });
    } catch (err) {
      dispatch({ type: CREATE_TM_SETTINGS_PRIORITY.ERROR, payload: err });
    }
  };

export const priorityUpdateActionHandler =
  (id: string | number, data: PriorityCreateType) =>
  async (dispatch: Dispatch<PriorityStateAction>) => {
    dispatch({ type: UPDATE_TM_SETTINGS_PRIORITY.LOADING, payload: true });

    try {
      const res = await updatePriority(id, data);

      dispatch({
        type: UPDATE_TM_SETTINGS_PRIORITY.SUCCESS,
        payload: res.data,
      });
    } catch (err) {
      dispatch({ type: UPDATE_TM_SETTINGS_PRIORITY.ERROR, payload: err });
    }
  };

export const priorityDeleteActionHandler =
  (id: string | number) => async (dispatch: Dispatch<PriorityStateAction>) => {
    dispatch({ type: DELETE_TM_SETTINGS_PRIORITY.LOADING, payload: true });

    try {
      const res = await deletePriority(id);

      dispatch({
        type: DELETE_TM_SETTINGS_PRIORITY.SUCCESS,
        payload: res.data,
      });
    } catch (err) {
      dispatch({ type: DELETE_TM_SETTINGS_PRIORITY.ERROR, payload: err });
    }
  };
